$(function () {
    $('.collapse').on('shown.bs.collapse', function(e) {
        $("#collapse-icon-extra").addClass('fa-chevron-up').removeClass('fa-chevron-down');
    });
    
    $('.collapse').on('hidden.bs.collapse', function(e) {
        $("#collapse-icon-extra").addClass('fa-chevron-down').removeClass('fa-chevron-up');
    });
});